import { SlidersHorizontal } from "lucide-react";
import { Button } from "@/components/ui/button";

interface TableFiltersProps {
  onClick: () => void;
  activeCount?: number;
  label?: string;
}

export function TableFilters({ onClick, activeCount, label = "Filters" }: TableFiltersProps) {
  return (
    <Button variant="outline" onClick={onClick}>
      <SlidersHorizontal className="mr-2 h-4 w-4" />
      {label} {activeCount ? `(${activeCount})` : ""}
    </Button>
  );
}
